import { Component, input } from '@angular/core';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { Icon } from '../icon';

@Component({
    selector: 'stby-tooltip',
    imports: [Icon, MatTooltipModule, TranslateModule],
    templateUrl: './tooltip.html',
    styleUrl: './tooltip.scss',
})
export class Tooltip {
    readonly tooltip = input<string>();
    readonly tooltipPosition = input<TooltipPosition>('right');
}
